﻿const navDropdown = {
    init: function () {

        this.classToAdd = "main-nav-visible";

        this.rootElm = document.querySelector("html");
        this.mainNavToggle = document.querySelector("[data-main-nav=\"toggle\"]");

        if (this.mainNavToggle && this.rootElm) {
            this.mainNavToggle.addEventListener("click", () => {
                this.rootElm.classList.toggle(this.classToAdd);
            });
        }


        // fjern class fra rootElm, hvis skærmen er større end nødvendigt
        this.mediaQuery = window.matchMedia("(min-width:992px)");

        var removeClass = function (mq, rootElm, classToAdd) {
            // hvis media querien er true, rootElm findes, og har den ønskede class - så fjern class'en
            if (rootElm && rootElm.classList.contains(classToAdd) && mq.matches) {
                rootElm.classList.remove(classToAdd);
            }
        };

        this.mediaQuery.addListener((mq) => removeClass(mq, this.rootElm, this.classToAdd));
        removeClass(this.mediaQuery, this.rootElm, this.classToAdd);

        this.initSubNavs();
    },

    initSubNavs: function () {

        this.carets = document.querySelectorAll("[data-main-nav=\"toggle-sub-nav\"]");
        if (!this.carets) return;

        window.addEventListener("click", (event) => {

            // check if the target is inside a toggler
            if (!event.target.closest("[data-main-nav=\"toggle-sub-nav\"]")) return;

            // find closest navItem (if any)
            let navItem = event.target.closest("[data-main-nav=\"parent\"]");
            if (!navItem) return;

            navItem.classList.toggle("show");

            let subNav = navItem.querySelector("[data-main-nav=\"sub-nav\"]");
            if (subNav) {

                // move the subnav offscreen, and unset the maxheight to be able to calc the height
                subNav.style.position = "absolute !important";
                subNav.style.bottom = "200vh !important";
                subNav.style.maxHeight = "none";

                // set the max-height of the navItem.
                // calculate total desired height (if navItem has .show, include the subNavs height, else exclude)
                let totalHeight = navItem.offsetHeight + (navItem.classList.contains("show") ? subNav.offsetHeight : -subNav.offsetHeight);

                // set max-height and transition-duration according to totalHeight
                navItem.style.setProperty("max-height", totalHeight + "px");
                navItem.style.setProperty("transition-duration", (totalHeight / 1000) + "s");

                // reset style changes to move the subnav back in the nav
                subNav.style.position = null;
                subNav.style.bottom = null;

            }



        });

    }
};

export default navDropdown.init();
